import { render, staticRenderFns } from "./FlashCardItem.vue?vue&type=template&id=dd4fed96&"
import script from "@/scripts/FlashCard/FlashCardLanding/components/FlashCardItem.js?vue&type=script&lang=js&"
export * from "@/scripts/FlashCard/FlashCardLanding/components/FlashCardItem.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports